export default "__VITE_ASSET__Cwu9GdTs__"